import CurrencyWithSymbol from './CurrencyWithSymbol';

export default CurrencyWithSymbol;
